<template>
<h1>Page</h1>
</template>

<script>
export default {
  name: "View"
}
</script>

<style scoped>

</style>